import axios from "axios";
import { ApiUrls, axiosConfig } from "../apiUrls";

export const getCitiesApi = () => {
    return axios.get(ApiUrls.GET_CITY, axiosConfig())
}
